import React from 'react';
import './footer.css';
import { Link } from 'react-router-dom';
import logoimg from '../images/Sri Krishnaa Logo.png';
import instagram from '../images/insta.png';
import foodImg from '../images/logooo.png';

export const Footer = () => {
  const handleEmailClickk = () => {
    window.location.href = `mailto:info@srikrishnaaindiancuisine.co.uk`;
  };

  return (
    <div>
      <footer className="footer-main-container">
        <div className="footer-primary">
          <div className="footer-column footer-about">
            <div className="footer-logo-container">
              <img src={logoimg} alt="Sri Krishnaa Logo" className="footer-logo-img" />
            </div>
          </div>

          <div className="footer-column footer-links">
            <h8 className="footer-quick-links-title">Quick Links</h8>
            <div className="footer-quick-links-wrapper">
              <ul className="footer-ul">
                <li><Link to="/Grababitenow">Grab A Bite Now</Link></li>
                <li><Link to="/Aboutus">About Us</Link></li>
                <li><Link to="/Contactusform">Contact Us</Link></li>
                <li><Link to="/privacypolicy">Privacy Policy</Link></li>
                <li><Link to="/terms">Terms and Conditions</Link></li>
                <li><Link to="/refundpolicy">Refund Policy</Link></li>
              </ul>
            </div>
          </div>

          <div className="footer-column footer-get-in-touch">
            <h8 className="footer-quick-links-title">Get in Touch</h8>
            <p className="footer-phone-number">Phone Number: +44 7554466904</p>
            <p className="footer-phone-number">Liverpool, UK</p>
            <p onClick={handleEmailClickk}>Email: info@srikrishnaaindiancuisine.co.uk</p>
            <div className="footer-social">
              <a target="_blank" rel="noopener noreferrer">
                <img src={instagram} alt="Instagram Logo" className="footer-social-icon" />
              </a>
            </div>
          </div>
        </div>

        <div className="footer-copyright">
          <p className="footer-rights">
            &copy; 2025 Sri Krishnaa Indian Cuisine | All Rights Reserved
          </p>

          <p className="footer-designed">
  <span className="footer-designed-text">Designed & Developed by</span>
  <a href="https://krinvy.com" target="_blank" rel="noopener noreferrer" className="krinvy-link">
    <img src={foodImg} alt="Food" className="footer-food-img" />
    Krinvy
  </a>
</p>

        </div>
      </footer>
    </div>
  );
};
